import loadable from "@loadable/component";
import { WarningOutlined } from "@ant-design/icons";

export const DynamicIcon = loadable<{ type: string }>(
  ({ type }) =>
    import(`../../node_modules/@ant-design/icons/es/icons/${type}.js`).catch(
      (error) => WarningOutlined
    ),
  {
    cacheKey(props) {
      return props.type;
    },
  }
);
